import { configureStore } from "@reduxjs/toolkit"
import { usersApi } from "./apis/usersApi"
import { setupListeners } from "@reduxjs/toolkit/query"
import { storesApi } from "./apis/storesApi"
import { productsApi } from "./apis/productsApi"

const store = configureStore({
  reducer: {
    [usersApi.reducerPath]: usersApi.reducer,
    [storesApi.reducerPath]: storesApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(usersApi.middleware)
      .concat(storesApi.middleware)
      .concat(productsApi.middleware),
})

setupListeners(store.dispatch)

export { store }
export {
  useFetchUsersQuery,
  useAddUserMutation,
  useRemoveUserMutation,
} from "./apis/usersApi"

export {
  useFetchStoresQuery,
  useAddStoreMutation,
  useRemoveStoreMutation,
} from "./apis/storesApi"

export {
  useFetchProductsQuery,
  useAddProductMutation,
  useRemoveProductMutation,
} from "./apis/productsApi"
